export const BILL_CART_ONLOAD_DISCOUNT_LOTTIE_SHOWN = "bill_cart_onload_discount_lottie_shown";
